// Linked dispatches have their own sales and payment reports. Their accounting
// location identifies the source, and does not make them outlet retail sales.
export const isOutletRetailOrder = order => order.dispatchOrderId == null
  && String(order.posUserName || '').trim().toUpperCase() !== 'DISPATCH'
  && (!order.stakeholderType || String(order.stakeholderType).trim().toLowerCase() === 'customer');

export const outletCollections = orders => orders.filter(isOutletRetailOrder).flatMap(order => {
  if (!order.creditSale) return [order];
  return (order.paymentBreakdown || [])
    .filter(payment => payment.channel !== 'Pay Later' && Number(payment.amount) > 0)
    .map((payment, index) => ({ ...order, sourceOrderId: order._id,
      _id: `${order._id}-receipt-${index}`, totalPrice: Number(payment.amount), paymentMethod: payment.channel }));
});
